<template>
    <div>
        <div class="installation-of-the-month-attachments-modal-window" :class="{'open': selected_submission !== null}" @click="selected_submission = null, selected_image_index = 0"
             v-if="selected_submission !== null">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="selected_submission = null, selected_image_index = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-content">
                    <div class="selected-image">
                        <img :src="`${$aws_bucket_url}${selected_submission.attachments[selected_image_index].file_url}`">
                        <a class="download-button" @click.prevent="downloadAttachment(selected_submission.attachments[selected_image_index].id)">
                            <i class="fal fa-download"></i>
                        </a>
                    </div>
                    <div v-if="selected_submission.winner" class="title-bar">
                        {{ selected_submission.friendly_month_submitted_at }}'s Winner - {{ selected_submission.company_name }}
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment,  index) in selected_submission.attachments" class="attachment">
                            <a @click.prevent="selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box mt-6">
            <div class="box-content">
                <div>
                    <div class="form-group">
                        <strong>Title: </strong>
                        {{ submission.title }}
                    </div>
                    <div class="form-group">
                        <strong>Description: </strong>
                        {{ submission.description }}
                    </div>
                    <div class="installation-of-the-month-attachments mb-3">
                        <div v-for="(attachment, index) in submission.attachments" class="attachment">
                            <div class="image" :style="attachmentThumbUrl(attachment)">
                                <span class="view-btn" @click="selected_submission = submission, selected_image_index = index"><i class="fal fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <strong>Company Name: </strong>
                            {{ submission.company_name }}
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <strong>Contact Name: </strong>
                            {{ submission.contact_name }}
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <strong>Email Address: </strong>
                            {{ submission.email }}
                        </div>
                        <div class="form-group flex-1">
                            <strong>Tel: </strong>
                            {{ submission.phone }}
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <strong>Linkedin: </strong>
                            {{ submission.linkedin }}
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <strong>Facebook: </strong>
                            {{ submission.facebook }}
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <strong>X (Twitter): </strong>
                            {{ submission.twitter }}
                        </div>
                        <div class="form-group flex-1">
                            <strong>Instagram: </strong>
                            {{ submission.instagram }}
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <strong>Systems / Colours</strong>
                        <ul>
                            <li>
                                Material: {{ submission.material_type }}
                            </li>
                            <li v-for="selected_system in submission.selected_systems">
                                {{ selected_system }}
                            </li>
                        </ul>
                        <div v-if="submission.material_type === 'PVC-U'">
                            <strong>External Colours</strong>
                            <ul>
                                <li v-for="colour in submission.selected_pvcu_external_colours">
                                    {{ colour }}
                                </li>
                            </ul>
                            <strong>Internal Colours</strong>
                            <ul>
                                <li v-for="colour in submission.selected_pvcu_internal_colours">
                                    {{ colour }}
                                </li>
                            </ul>
                            <strong>Base Colours</strong>
                            <ul>
                                <li v-for="colour in submission.selected_pvcu_base_colours">
                                    {{ colour }}
                                </li>
                            </ul>
                        </div>
                        <div v-if="submission.material_type === 'Aluminium'">
                            <strong>External Colours</strong>
                            <ul>
                                <li v-for="colour in submission.selected_aluminium_colours">
                                    {{ colour }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <strong>Window type(s) / number installed: </strong>
                            {{ submission.window_types }}
                        </div>
                        <div class="form-group flex-1 pr-3">
                            <strong>Doors type(s) / number installed: </strong>
                            {{ submission.door_types }}
                        </div>
                        <div class="form-group flex-1">
                            <strong>Hardware installed: </strong>
                            {{ submission.hardware_installed }}
                        </div>
                    </div>
                    <div class="flex">
                        <div class="form-group flex-1 pr-3">
                            <strong>Any interesting features or points of note: </strong>
                            {{ submission.interesting_features }}
                        </div>

                        <div class="form-group flex-1">
                            <strong>Other information: </strong>
                            {{ submission.other_information }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        logged_in_user: {
            required: true,
        },
        entry: {
            required: true,
        },
    },
    data() {
        return {
            submission: {},
            selected_submission: null,
            selected_image_index: 0,
            systems_installed_dropdown_open: false,
            pvcu_external_colours_dropdown_open: false,
            pvcu_internal_colours_dropdown_open: false,
            pvcu_base_colours_dropdown_open: false,
            aluminium_colours_dropdown_open: false,
            pvcu_external_colours: [
                'Agate Grey',
                'AnTeak',
                'Anthracite Grey',
                'Anthracite Grey Smooth',
                'Basalt Grey Smooth',
                'Black Brown',
                'Black Ulti-Matt',
                'Buckingham Grey',
                'Chartwell Green',
                'Claystone',
                'Cream',
                'Dark Green',
                'Dark Red',
                'Flemish Gold Smooth',
                'Hazy Grey',
                'Honey Oak Super Matt',
                'Irish Oak',
                'Kensington Grey',
                'Light Oak',
                'Pebble Grey',
                'Pyrite',
                'Rosewood',
                'Sage Smooth',
                'Silver D Smooth',
                'Slate Grey',
                'Slate Grey Finesse',
                'Steel Blue',
                'Swamp Oak',
                'White',
                'Windsor',
            ],
            pvcu_internal_colours: [
                'Agate Grey',
                'AnTeak',
                'Anthracite Grey',
                'Anthracite Grey Smooth',
                'Basalt Grey Smooth',
                'Black Brown',
                'Black Ulti-Matt',
                'Buckingham Grey',
                'Chartwell Green',
                'Claystone',
                'Cream',
                'Dark Green',
                'Dark Red',
                'Flemish Gold Smooth',
                'Hazy Grey',
                'Honey Oak Super Matt',
                'Irish Oak',
                'Kensington Grey',
                'Light Oak',
                'Pebble Grey',
                'Pyrite',
                'Rosewood',
                'Sage Smooth',
                'Silver D Smooth',
                'Slate Grey',
                'Slate Grey Finesse',
                'Steel Blue',
                'Swamp Oak',
                'White',
                'Windsor',
            ],
            pvcu_base_colours: [
                'Brown',
                'Cream',
                'Grey',
                'Tan',
                'White',
            ],
            aluminium_colours: [
                'Signal White',
                'Anthracite Grey',
                'Anthracite Grey / Signal White',
                'Jet Black',
                'Jet Black / Signal White',
                'Cream',
                'Agate Grey',
                'Slate Grey',
                'Chocolate Brown',
                'Anthracite Grey Textured',
            ],
        };
    },
    mounted() {
        this.submission = this.entry;
    },
    methods: {
        attachmentUrl(attachment) {
            return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.file_url}')`};
        },
        attachmentThumbUrl(attachment) {
            if (attachment.thumbExists) {
                return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.thumbnail_url}')`};
            }
            return this.attachmentUrl(attachment);
        },
        downloadAttachment(attachment_id) {
            axios.post('/installation-of-the-month/download-attachment', {
                attachment_id: attachment_id,
            }).then((response) => {
                window.location.href = response.data;
            });
        },
    },
}
</script>
